import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTabs from '../../components/CustomTabs';
import Header from '../../components/Header';
import MonthlyMachinesTable from '../../components/tables/operations/summary/MonthlyMachinesTable';
import MonthlyRentalTypesTable from '../../components/tables/operations/summary/MonthlyRentalTypesTable';
import MonthlyToolsTable from '../../components/tables/operations/summary/MonthlyToolsTable';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { getTomorrowDate } from '../../utils/dates';
import { localStorageKeys } from '../../utils/enums';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';
import MonthlyReportsTable from '../../components/tables/operations/summary/MonthlyReportsTable';
import MonthlySitesTable from '../../components/tables/operations/summary/MonthlySitesTable';
import { usePageTitle } from '../../hooks/usePageTitle';
import MonthlyTempWorkerTypesTable from '../../components/tables/operations/summary/MonthlyTempWorkerTypesTable';
import MonthlySubContractorTypesTable from '../../components/tables/operations/summary/MonthlySubContractorTypesTable';
import PrimaryBox from '../../components/PrimaryBox';
import PayrollReportsTable from '../../components/tables/operations/summary/PayrollReportsTable';

const SummaryPage: React.FC = () => {
    const { t } = useTranslation();
    usePageTitle(capitalizeFirstLetter(t('summary')));

    const [currentDate, setCurrentDate] = useState(new Date(getItemFromLocalStorage(localStorageKeys.SUMMARYDATE) || getTomorrowDate()));
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.SUMMARY) || '0'));

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.SUMMARY, newValue.toString());
    };

    const handleDateChange = (newDate: string) => {
        setCurrentDate(new Date(newDate));
        storeItemToLocalStorage(localStorageKeys.SUMMARYDATE, newDate);
    };

    return (
        <PrimaryBox>
            <Header
                title={t('operations')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('summary')) }]}
                subTitle={capitalizeFirstLetter(t('summary'))}
                initialDate={currentDate}
                onDateChange={(newDate) => handleDateChange(newDate.toISOString())}
                mode="month"
            ></Header>
            <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabLabels={[t('workers'), t('payrolls'), t('sites'), t('machines'), t('tools'), t('rentals'), t('tempWorkers'), t('subContractors')]}
            />
            {selectedTab === 0 && <MonthlyReportsTable currentDate={currentDate} />}
            {selectedTab === 1 && <PayrollReportsTable currentDate={currentDate} />}
            {selectedTab === 2 && <MonthlySitesTable currentDate={currentDate} />}
            {selectedTab === 3 && <MonthlyMachinesTable currentDate={currentDate} />}
            {selectedTab === 4 && <MonthlyToolsTable currentDate={currentDate} />}
            {selectedTab === 5 && <MonthlyRentalTypesTable currentDate={currentDate} />}
            {selectedTab === 6 && <MonthlyTempWorkerTypesTable currentDate={currentDate} />}
            {selectedTab === 7 && <MonthlySubContractorTypesTable currentDate={currentDate} />}
        </PrimaryBox>
    );
};

export default SummaryPage;
